import type { SerializedMeterModel } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { DeleteMeterModelsArg } from 'lib/services';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useDeleteMeterModel = (): UseMutationResult<SerializedMeterModel, unknown, DeleteMeterModelsArg> => {
  const queryClient = useQueryClient();
  const { meterModelsApiClient } = useServices();
  const { success, error } = useAppNotifications();

  return useMutation({
    mutationKey: MUTATION_KEYS.meterModels.deleteOne(),
    mutationFn: async (arg: DeleteMeterModelsArg) => await meterModelsApiClient.delete(arg),
    onError: err => {
      console.error(err);
      error({
        message: 'There was an error while deleting meter model',
        description: getErrorMessage(err),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.meterModels.all());
      success({
        message: `Meter model deleted`,
      });
    },
  });
};
